import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MapPin, Phone, Clock, MessageCircle } from "lucide-react";

export default function Branches() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/branches").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16" data-testid="branches-page">
      <div className="overline text-[#1a2d5e]">Visit us</div>
      <h1 className="font-display font-black text-5xl mt-2 text-[#0b1838] tracking-tighter">Our branches</h1>
      <p className="mt-3 text-slate-600 max-w-xl">Drop in for a hands-on demo, in-store repairs, or to redeem your trade-in credit.</p>

      <div className="mt-12 grid md:grid-cols-2 gap-6" data-testid="branch-location-grid">
        {items.map((b) => (
          <div key={b.id} className="border border-slate-200 rounded-xl bg-white p-7 hover:shadow-lg hover:border-slate-300 transition-all" data-testid={`branch-card-${b.id}`}>
            <div className="overline text-[#1a2d5e]">JAS Branch</div>
            <div className="font-display font-bold text-2xl mt-2 text-[#0b1838]">{b.name}</div>
            <ul className="mt-5 space-y-3 text-sm text-slate-600">
              <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-[#1a2d5e] shrink-0" />{b.address}</li>
              {b.phone ? (
                <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 text-[#1a2d5e] shrink-0" /><a href={`tel:${b.phone.replace(/\s/g, "")}`} className="hover:underline">{b.phone}</a></li>
              ) : (
                <li className="flex items-start gap-2 text-slate-400 italic"><Phone size={16} className="mt-0.5 shrink-0" />Phone — coming soon</li>
              )}
              <li className="flex items-start gap-2"><Clock size={16} className="mt-0.5 text-[#1a2d5e] shrink-0" />{b.hours}</li>
            </ul>
            <div className="mt-6 flex flex-wrap gap-2">
              <a
                href={`https://maps.google.com/?q=${encodeURIComponent(b.map_query || b.address)}`}
                target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 border border-[#1a2d5e] text-[#1a2d5e] font-semibold text-sm rounded-md hover:bg-[#1a2d5e] hover:text-white transition-colors"
                data-testid={`branch-map-${b.id}`}
              >
                Open in Maps
              </a>
              {b.whatsapp && (
                <a
                  href={`https://wa.me/${b.whatsapp}`}
                  target="_blank" rel="noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-[#25D366] text-white font-semibold text-sm rounded-md hover:bg-[#1da851] transition-colors"
                  data-testid={`branch-whatsapp-${b.id}`}
                >
                  <MessageCircle size={14} /> WhatsApp
                </a>
              )}
              {b.phone && (
                <a
                  href={`tel:${b.phone.replace(/\s/g, "")}`}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-[#1a2d5e] text-white font-semibold text-sm rounded-md hover:bg-[#0b1838] transition-colors"
                  data-testid={`branch-call-${b.id}`}
                >
                  <Phone size={14} /> Call
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
